<template>
    <div>
        <div class="label label-combi">
            <label>
                {{ label }}
            </label>
            <div class="label-value">
                {{ labelDisplay }} MBit/s
            </div>
        </div>

        <slider
            ref="slider"
            v-model="labelValue"
            :max="sliderMax"
            :min="0"
            :step="sliderInterval"
            :value="logValue"
            @change="update"
        />
    </div>
</template>

<script>
import Slider from '../../../../../abstracts/slider/Slider.vue';

export default {
    components: { Slider },
    props: [
        'label',
        'speed',
        'maxSpeed',
    ],
    emits: ['update:speed'],
    data() {
        return {
            pow: 2,
            interval: 10,
            labelValue: 0,
        };
    },
    computed: {
        maxValue() {
            return this.maxSpeed;
        },
        labelDisplay() {
            return this.logValueToRealValue(this.labelValue);
        },
        multiplier() {
            const maxVar = this.maxSpeed ** this.pow;
            return this.maxSpeed / maxVar;
        },

        sliderMax() {
            return this.realValueToLogValue(this.maxSpeed);
        },

        logValue() {
            return this.realValueToLogValue(this.speed);
        },

        sliderInterval() {
            if (this.pow === 1) {
                return this.interval;
            }
            return 10;
        },

        logInterval() {
            return Math.min(
                this.maxSpeed,
                this.interval,
            );
        },
    },
    watch: {
        speed: {
            handler(newSpeed) {
                this.labelValue = this.realValueToLogValue(newSpeed);
            },
            immediate: true,
        },
    },
    methods: {
        logValueToRealValue(value) {
            if (this.pow === 1) {
                return value;
            }
            let newVar = value ** this.pow;
            newVar *= this.multiplier;

            return this.roundValue(newVar);
        },
        update(value) {
            this.$emit('update:speed', this.logValueToRealValue(value));
        },
        realValueToLogValue(value) {
            if (this.pow === 1) {
                return value;
            }
            let newVar = value / this.multiplier;
            newVar = Math.sqrt(newVar);
            if (Number.isNaN(newVar)) {
                newVar = 0;
            }

            // round to nearest interval
            newVar = this.roundValue(newVar);

            return newVar;
        },

        roundValue(value) {
            return this.interval * Math.round(value / this.logInterval);
        },
    },
};

</script>
